import { CommonModule } from '@angular/common';
import { Component, OnInit, ChangeDetectionStrategy, Input, ChangeDetectorRef } from '@angular/core';
import { PlanType,  SubscriptionStatus } from '@fitness-force/enum';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'subscription-status',
  templateUrl: './subscription-status.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule]
})
export class SubscriptionStatusComponent implements OnInit {
  @Input() additionData = new BehaviorSubject(null);
  @Input() columnData  = new BehaviorSubject(null);
  type!: any;
  constructor(private cd: ChangeDetectorRef) { }
  ngOnInit() {
    this.columnData.subscribe({next:(item:any)=>{
      this.setPlanType(item);
    }});
  }
  setPlanType(cData:any) {
    if(cData?.clt_subs_status)
    this.type = SubscriptionStatus[cData?.clt_subs_status as keyof typeof SubscriptionStatus]
  }
}
